import Bell from './Bell'

export default Bell
// eslint-disable-next-line import/export
export * from './Bell'
